/**
 *
 * Asynchronously loads the component for AdvisorDashboard
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorDashboard = lazyLoad(
  () => import('./index'),
  module => module.AdvisorDashboard,
);
